module.exports = __webpack_public_path__ + "img/22.c6c7a8ad.jpg";